/**
 * 限时首充的弹窗
 */

import { useModal } from '@ebay/nice-modal-react';
import { useCountDown } from 'ahooks';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { implog as impLog } from '@/api/implog';
import Button from '@/components/button';
import { modalStore } from '@/stores/modal';
import rechargeStore from '@/stores/recharge';

import styles from './index.module.less';

const FirstRecharge = () => {
  const modal = useModal();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { firstRecharge } = rechargeStore;

  const [, countdown] = useCountDown({
    leftTime: firstRecharge.leftTime,
    onEnd() {
      firstRecharge.show = false;
      modal.hide();
    }
  });

  const goFirstRecharge = () => {
    modal.hide();
    if (pathname === '/game') {
      modalStore.closeTaskChain();
    }
    if (!firstRecharge.rechargeTime) {
      impLog('first_recharge_modal_recharge');
    }
    const page = firstRecharge.rechargeTime ? '/first-recharge/recharged' : '/first-recharge/not-recharged';
    navigate(page);
  };

  useEffect(() => {
    impLog('first_recharge_modal_show');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.title}>First Deposit</div>
      <div className={styles.tip}>Bonus +270%</div>
      <div className={styles.desc}>
        <p>Deposit any amount to unlock withdrawals</p>
        <p>Withdrawals may arrive in as fast as 30 seconds</p>
        <p>Get over $10 in free bonuses daily</p>
      </div>
      <div className={styles.countdown}>
        <div className={styles.item}>{`${countdown.hours}`.padStart(2, '0')}</div>
        <div className={styles.line}>:</div>
        <div className={styles.item}>{`${countdown.minutes}`.padStart(2, '0')}</div>
        <div className={styles.line}>:</div>
        <div className={styles.item}>{`${countdown.seconds}`.padStart(2, '0')}</div>
      </div>
      <Button className={styles.button} type="success" onClick={goFirstRecharge}>
        Deposit
      </Button>
    </div>
  );
};

export default observer(FirstRecharge);
